import React from "react";
import "./PropertyEnquiry.css";

const PropertyEnquiry = () => {
    return (
        <div className="enquiry-wrapper">
            <h2 className="enquiry-title">Get in Touch / Enquire Now</h2>

            <div className="enquiry-buttons">
                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSel4HLQKNJan81qoINcTRfu_G0wOZnh1RIHbm58m7bnalh5Sw/viewform?usp=header"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="enquiry-btn"
                >
                    Visitor Enquiry
                </a>

                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSf98S2yjWPQyBHY-S2Yu2Diq6tHC9-WZiK1HReQ5EA3g9g4yg/viewform?usp=publish-editor"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="enquiry-btn"
                >
                    Daily Call Enquiry
                </a>

                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdjPgyRnY20cx7e0A3NxRkog_VHkM0jaNywKBVF0h5F5V-7lQ/viewform?usp=header"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="enquiry-btn"
                >
                    Booking Enquiry
                </a>
            </div>
        </div>
    );
};

export default PropertyEnquiry;
